// 字典启用禁用
export enum DICTIONARY_STATUS_ENUM {
  STRING = 'STRING',
  NUMBER = 'NUMBER',
  BOOLEAN = 'BOOLEAN',
  JSON = 'JSON',
  HTML = 'HTML',
}

export const DICTIONARY_STATUS_LIST = [
  {
    label: '字符串',
    value: DICTIONARY_STATUS_ENUM.STRING,
  },
  {
    label: '数字',
    value: DICTIONARY_STATUS_ENUM.NUMBER,
  },
  {
    label: '布尔值',
    value: DICTIONARY_STATUS_ENUM.BOOLEAN,
  },
  {
    label: 'JSON',
    value: DICTIONARY_STATUS_ENUM.JSON,
  },
  {
    label: 'HTML',
    value: DICTIONARY_STATUS_ENUM.HTML,
  },
];
